import React from 'react';
import {
  translate,
  BooleanField,
  Datagrid,
  DateField,
  DateInput,
  Delete,
  Edit,
  Filter,
  FormTab,
  List,
  Show,
  SimpleShowLayout,
  RichTextField,
  ReferenceField,
  LongTextInput,
  NullableBooleanInput,
  NumberField,
  ReferenceManyField,
  TabbedForm,
  TextField,
  TextInput,
  BooleanInput,
  NumberInput,
  downloadCSV
} from 'react-admin';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import Person from '@material-ui/icons/Person';
import Tooltip from '@material-ui/core/Tooltip';

import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Toolbar from '@material-ui/core/Toolbar';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TableCell from '@material-ui/core/TableCell';
import { CreateButton, ExportButton, RefreshButton } from 'react-admin';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import SegmentsInput from '../business/SegmentsInput';
import SegmentsField from '../business/SegmentsField';
import GamesField from '../users/GamesField';
import Header from './Header';
export const UserIcon = Person;

const UserFilter = props => (
  <Filter {...props}>
    <TextInput source="name_or_email" label="Name or email" />
    <TextInput source="business_name" label="Business Name" />
    <NumberInput source="business_id" label="Business id" />
    <TextInput source="exclude_business_names" label="Exclude Businesses" />
    <TextInput source="countries" />
    <TextInput source="industries" />
    <DateInput source="from_trough" />
    <DateInput source="to_trough" />
    <NumberInput source="exercise_count" label="Number of Exercises >=" />
    <NumberInput source="game_count" label="Number of Games >=" />
    <DateInput source="created_at_gte" label="Created After" />
    <DateInput source="created_at_lte" label="Created Before" />
    <SegmentsInput />
  </Filter>
);

const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9'
  }
}))(Tooltip);

const exporter = users => {
  const header = [
    'Email',
    'Games',
    'Exercises',
    'Business Type',
    'Business Name',
    'Licence',
    'Good Trough',
    'Country',
    'Industry'
  ];

  const usersForExport = [
    ['Users', document.getElementById('u_total_users').value],
    ['Active Users', document.getElementById('u_total_active_users').value],
    ['Games', document.getElementById('u_total_games').value],
    ['Played Games', document.getElementById('u_total_played_games').value],
    ['Exercises', document.getElementById('u_total_exerciese').value],
    ['Teams', document.getElementById('u_total_teams').value],
    [],
    header
  ];

  users.map(user => {
    usersForExport.push([
      user.email,
      user.number_of_games_created,
      user.number_of_exercises,
      user.business_type,
      user.business_name,
      user.licence_count,
      user.good_trough,
      user.country,
      user.industry
    ]);
  });
  const csv = convertToCSV({
    data: usersForExport
  });
  downloadCSV(csv, 'users');
};

const customAction = (filters, filterValues) => {
  window.open(
    '/api/users.xls?sort=id&filter=' +
      encodeURIComponent(JSON.stringify(filterValues), '_blank')
  );
  console.log('custom action ');
  console.dir(filterValues);
};

const PostActions = ({
  bulkActions,
  basePath,
  currentSort,
  displayedFilters,
  exporter,
  filters,
  filterValues,
  onUnselectItems,
  resource,
  selectedIds,
  showFilter,
  total
}) => (
  <CardActions>
    {bulkActions &&
      React.cloneElement(bulkActions, {
        basePath,
        filterValues,
        resource,
        selectedIds,
        onUnselectItems
      })}
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button'
      })}

    <RefreshButton />
    {/* Add your custom actions */}
    {
      <Button
        color="primary"
        onClick={() => customAction(filters, filterValues)}
      >
        Download excel
      </Button>
    }
  </CardActions>
);

const UserPagination = ({ page, perPage, total, setPage }) => {
  const nbPages = Math.ceil(total / perPage) || 1;
  const goPages = 10;
  return (
    nbPages > 1 && (
      <Toolbar>
        {page > 1 && (
          <span>
            {page != 1 && (
              <Button
                color="primary"
                key="prev"
                icon={<ChevronLeft />}
                onClick={() => setPage(1)}
              >
                First
              </Button>
            )}
            {page - goPages > 0 && (
              <Button
                color="primary"
                key="prev"
                icon={<ChevronLeft />}
                onClick={() => setPage(page - goPages)}
              >
                Prev({goPages})
              </Button>
            )}
            <Button
              color="primary"
              key="prev"
              icon={<ChevronLeft />}
              onClick={() => setPage(page - 1)}
            >
              Prev
            </Button>
          </span>
        )}
        <Typography variant="body1">
          {page <= nbPages && page + '/' + nbPages}
        </Typography>
        {page !== nbPages &&
          page <= nbPages && (
            <span>
              <Button
                color="primary"
                key="next"
                icon={<ChevronRight />}
                onClick={() => setPage(page + 1)}
                labelPosition="before"
              >
                Next
              </Button>
              {page + goPages <= nbPages && (
                <Button
                  color="primary"
                  key="next"
                  icon={<ChevronRight />}
                  onClick={() => setPage(page + goPages)}
                  labelPosition="before"
                >
                  Next({goPages})
                </Button>
              )}
              {page != nbPages && (
                <Button
                  color="primary"
                  key="next"
                  icon={<ChevronRight />}
                  onClick={() => setPage(nbPages)}
                  labelPosition="before"
                >
                  Last
                </Button>
              )}
            </span>
          )}
      </Toolbar>
    )
  );
};

export const UserList = ({ permissions, ...props }) => (
  <div>
    <Header {...props} />
    <List
      {...props}
      pagination={<UserPagination />}
      filters={<UserFilter />}
      exporter={exporter}
      actions={<PostActions permissions={permissions} />}
    >
      <Datagrid>
        <TextField source="email" />
        <GamesField />
        <NumberField source="number_of_played_games" label="Played Games" />
        <NumberField
          source="number_of_games_owned_not_created"
          label="Co-owned Games"
        />
        <NumberField
          source="number_of_owned_played_games"
          label="Co-Played Games"
        />
        <NumberField source="number_of_exercises" label="Exercises" />
        <SegmentsField />
        <TextField source="business_name" />
        <NumberField source="licence_count" label="Licence" />
        <DateField source="good_trough" type="date" />
        <TextField source="country" />
        <TextField source="industry" />
      </Datagrid>
    </List>
  </div>
);



// WEBPACK FOOTER //
// ./src/users/index.js